import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
@Component({
    selector: "app-free-week-confirmation",
    templateUrl: "./free-week-confirmation.component.html",
    styleUrls: ["./free-week-confirmation.component.scss"],
    standalone: true,
    imports: [IonicModule, TranslatePipe],
})
export class FreeWeekConfirmationComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<FreeWeekConfirmationComponent>,
    public translate: TranslateService,
    private authService: AuthService
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        if (l) {
          translate.use(l ? l : "en");
        }
      },
      (err) => {
        return err;
      }
    );
  }

  ngOnInit() {}

  GoToSyndicates() {
    this.dialogRef.close(true);
  }
}
